import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=0fb4419c"
import script from "./drop.vue?vue&type=script&lang=js"
export * from "./drop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports